<template>
  <p
		v-if="headerMessage"
		class="subtitle"
		v-html="headerMessage"
	></p>
  <form
			v-if="carInfo"
			@submit="saveAndContinue()"
	>
    <div class="form-title">
      <h3>פרטי הרכב</h3>
      <span class="required">* שדות חובה</span>
    </div>
    <div class="form-group">
      <div class="form-field transparent bold">
        <label for="model">יצרן ודגם</label>
        <input
						type="text"
						id="model"
						v-model="carInfo.title"
						readonly
				/>
      </div>
      <div class="form-field transparent bold">
        <label for="year">שנה</label>
        <input
          type="text"
          min="1900"
          :max="currentYear"
          id="year"
          v-model="carInfo.year"
					required
        />
      </div>
    </div>
    <div class="form-group">
      <div class="form-field">
        <label for="km">ק"מ</label>
        <input
						type="number"
						id="km"
						v-model="carInfo.km"
				/>
      </div>
      <div class="form-field">
        <label for="prevOwner">יד</label>
        <input
          type="number"
          id="prevOwner"
          :min="1"
          :max="30"
          v-model="carInfo.past_owners"
        />
      </div>
      <div class="form-field">
        <label for="price">מחיר</label>
        <input type="text" id="price" v-model="carInfo.price" />
      </div>
    </div>
    <div class="form-title">
      <h3>גלריית תמונות</h3>
    </div>
    <div class="form-group">
      <AddGalleryFiles
					:car="carInfo"
					:multiple="true"
					@thumbnailIndex="updateThumbnailIndex"
			/>
    </div>
    <div class="form-actions">
      <button type="button" @click="goBack()">חזרה</button>
      <button type="submit">המשך</button>
      <button type="button" class="delete" @click="deleteCarAction">מחיקה</button>
    </div>
  </form>
</template>
<script>
import AddGalleryFiles from "../../components/addGalleryFiles.vue";
import {mapActions} from "vuex";

export default {
  name: "CarDetails",
  components: {
    AddGalleryFiles,
  },
  mounted() {
		this.getCarDetails()
  },
  data() {
    return {
      carInfo: null,
      currentYear: new Date().getFullYear(),
      headerMessage: "מחפש נתוני רכב...",
    };
  },
  methods: {
    async getCarDetails() {
			if(this.$route.params.id){
				const id = this.$route.params.id;
				if(/^\d+$/.test(id)){
					this.carInfo = await this.locateCar(id)
					const textFormat =
							"רכב מספר %%car_number%% אותר בהצלחה, ניתן להמשיך ולמלא פרטי מודעה.";
					this.headerMessage = textFormat.replace(
							"%%car_number%%",
							this.carInfo.plate_number
					);
				}else{
					this.$store.commit('currentCarId', this.$route.params.id)
					this.carInfo = this.$store.getters.currentCar
					this.headerMessage = null;
				}
			}
		},
		updateThumbnailIndex(index){
			this.carInfo.thumbnail_index = index
		},
    goBack() {
      this.$router.push({
				name: 'agents-area'
			});
			/*this.$router.push({
				name: 'locate-vehicle'
			});*/
    },
    saveAndContinue() {
			this.saveCar(this.carInfo)
      /*this.$router.push({
				name: 'car-summary',
				params: {
					id: this.carInfo.id
				}
			});*/
			this.$router.push({
				name: 'thankyou',
				params: {
					id: this.carInfo.id
				}
			});
    },
		async deleteCarAction(){
			if(await this.deleteCar(this.carInfo)){
				this.$router.push({
					name: 'agents-area'
				})
			}
		},
		...mapActions([
				'locateCar',
				'saveCar',
				'deleteCar'
		])
  },
};
</script>
